import { AlertTriangle, MapPin, PawPrint } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

export const StoryCzteryLapyUrgent1 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />


      {/* Pulse alert badge - top safe zone */}
      <div
        style={{
          position: "absolute",
          top: "300px",
          left: "50%",
          transform: "translateX(-50%)",
          background: "linear-gradient(135deg, #E8763A 0%, #D85F1F 100%)",
          borderRadius: "999px",
          padding: "20px 40px",
          display: "flex",
          alignItems: "center",
          gap: "14px",
          zIndex: 3,
          boxShadow: "0 12px 40px rgba(216,95,31,0.45)",
        }}
      >
        <AlertTriangle style={{ width: "36px", height: "36px", color: "#FFFFFF" }} />
        <span style={{ fontSize: "32px", fontWeight: 800, color: "#FFFFFF", letterSpacing: "2px" }}>
          PILNA POTRZEBA
        </span>
      </div>

      {/* Main content */}
      <div
        style={{
          position: "absolute",
          top: "440px",
          left: "80px",
          right: "80px",
          bottom: "420px",
          display: "flex",
          flexDirection: "column",
          zIndex: 2,
        }}
      >
        {/* Headline */}
        <div style={{ marginBottom: "60px" }}>
          <p
            style={{
              fontSize: "100px",
              fontWeight: 800,
              color: "#FFFFFF",
              lineHeight: 1.0,
              margin: 0,
              textShadow: "0 6px 28px rgba(0,0,0,0.45)",
            }}
          >
            Pomoc
          </p>
          <p
            style={{
              fontSize: "100px",
              fontWeight: 800,
              color: "#FFD480",
              lineHeight: 1.0,
              margin: "8px 0 0",
              textShadow: "0 6px 28px rgba(0,0,0,0.45)",
            }}
          >
            potrzebna
          </p>
          <p
            style={{
              fontSize: "100px",
              fontWeight: 800,
              color: "#FFFFFF",
              lineHeight: 1.0,
              margin: "8px 0 0",
              textShadow: "0 6px 28px rgba(0,0,0,0.45)",
            }}
          >
            teraz
          </p>
        </div>

        {/* Description card */}
        <div
          style={{
            background: "rgba(255,255,255,0.96)",
            borderRadius: "32px",
            padding: "44px 48px",
            boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
            marginBottom: "32px",
          }}
        >
          <p
            style={{
              fontSize: "34px",
              fontWeight: 700,
              color: "#2D5A3D",
              lineHeight: 1.35,
              margin: 0,
            }}
          >
            Wolontariuszka ze Stowarzyszenia Cztery Łapy prowadzi pilną zbiórkę na ratunek dla Wiesia. Każda złotówka ma znaczenie.
          </p>
        </div>

        {/* Link CTA - bez linku, do wklejenia recznie na IG */}
        <div
          style={{
            background: "linear-gradient(135deg, #E8763A 0%, #D85F1F 100%)",
            borderRadius: "28px",
            padding: "32px 44px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "18px",
            boxShadow: "0 14px 40px rgba(216,95,31,0.4)",
          }}
        >
          <span style={{ fontSize: "44px" }}>👇</span>
          <span style={{ fontSize: "40px", fontWeight: 800, color: "#FFFFFF", letterSpacing: "1px" }}>
            Link do zbiórki
          </span>
        </div>
      </div>

      {/* Shelter info - na samym dole */}
      <div
        style={{
          position: "absolute",
          bottom: "260px",
          left: "80px",
          right: "80px",
          zIndex: 2,
          background: "linear-gradient(135deg, #2D5A3D 0%, #1f4530 100%)",
          borderRadius: "28px",
          padding: "32px 40px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          boxShadow: "0 16px 48px rgba(0,0,0,0.3)",
        }}
      >
        <p style={{ fontSize: "40px", fontWeight: 800, color: "#FFFFFF", margin: 0, lineHeight: 1.15 }}>
          Stowarzyszenie Cztery Łapy
        </p>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "4px" }}>
          <MapPin style={{ width: "24px", height: "24px", color: "#A8D5BB" }} />
          <span style={{ fontSize: "28px", fontWeight: 600, color: "#A8D5BB" }}>
            Olecko
          </span>
        </div>
      </div>

      {/* Brand badge - bottom */}
      <div
        style={{
          position: "absolute",
          bottom: "120px",
          left: "50%",
          transform: "translateX(-50%)",
          background: "rgba(255,255,255,0.95)",
          borderRadius: "999px",
          padding: "12px 24px 12px 16px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          zIndex: 3,
          boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
        }}
      >
        <div
          style={{
            width: "44px",
            height: "44px",
            borderRadius: "12px",
            background: "linear-gradient(135deg, #2D5A3D 0%, #4E8A6E 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <PawPrint style={{ width: "26px", height: "26px", color: "#FFFFFF" }} />
        </div>
        <span style={{ fontSize: "26px", fontWeight: 800, color: "#2D5A3D", letterSpacing: "0.5px" }}>
          GdzieSchronisko
        </span>
      </div>
    </div>
  );
};
